import React, { useEffect } from 'react'
import { Card, Col, Row, Dropdown, Menu, Skeleton, Tag, Tooltip } from 'antd'
import { IoIosArrowDropdownCircle } from 'react-icons/io'
import { useDispatch } from 'react-redux'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { eventActions, useEventSelector } from 'store/eventSlice/eventReducer'
import {
  acceptEventInvite,
  getAllPresenterEvents,
  rejectEventInvite,
} from 'store/eventSlice/eventActions'
import { timeInAgo } from 'utils'
import { GrView } from 'react-icons/gr'
import { useHistory } from 'react-router-dom'

const EventInvites = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { loading, events } = useEventSelector()
  const { user } = useAuthSelector()

  useEffect(() => {
    dispatch(getAllPresenterEvents(user.email))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onAcceptClick = (eventId) => {
    dispatch(acceptEventInvite(eventId, user.email))
  }

  const onRejectClick = (eventId) => {
    dispatch(rejectEventInvite(eventId, user.email))
  }

  const onViewEventClick = (eventId) => {
    dispatch(eventActions.setEvent(null))
    history.push(`/events/${eventId}`)
  }

  const customMenu = (eventId, isPending) => (
    <>
      {isPending ? (
        <Menu>
          <Menu.Item
            id="acceptInvite"
            key={1}
            onClick={() => onAcceptClick(eventId)}
          >
            Accept Invitation
          </Menu.Item>
          <Menu.Item
            id="rejectInvite"
            key={2}
            onClick={() => onRejectClick(eventId)}
          >
            Reject Invitation
          </Menu.Item>
        </Menu>
      ) : (
        <></>
      )}
    </>
  )

  const PRESENTER_EVENTS = events.filter(
    (event) =>
      event?.EventType === 'Fundraiser' &&
      event?.PresenterEmail === user.email &&
      event?.AcceptanceStatus !== 'Rejected' &&
      (event?.startEvent === undefined || event?.startEvent === true),
  )

  return (
    <Card
      className="header-solid"
      bordered={false}
      title={[
        <>
          <h6 className="mb-0 t-text-2xl">My Invites</h6>
          <h6 className="font-regular">
            You are invited to host the following events
          </h6>
        </>,
      ]}
    >
      <div style={{ minHeight: 'calc(100vh - 250px)' }}>
        <Skeleton loading={loading} active paragraph={{ rows: 18 }}>
          <Col span={24}>
            {PRESENTER_EVENTS.length === 0 && (
              <Card className="t-h-96 t-w-full t-flex t-justify-center t-items-center">
                <div>No Invites</div>
              </Card>
            )}
            <div id="presenterEventList">
              {PRESENTER_EVENTS.map((item, index) => (
                <Card key={index} className="w-full t-my-2 t-p-2">
                  <Row gutter={[24, 0]} className="t-flex t-justify-between">
                    <div className="font-bold t-flex t-space-x-4">
                      <div>
                        Organization{' '}
                        <span className="t-italic t-text-secondary-100">
                          {item?.OrganizationName}
                        </span>{' '}
                        invited you to present the event{' '}
                        <span className="t-italic t-text-secondary-100">
                          {item?.Title}
                        </span>
                      </div>
                      <div>
                        {item?.AcceptanceStatus === 'Accepted' && (
                          <Tag color="green" className="font-bold">
                            Accepted
                          </Tag>
                        )}
                        {item?.AcceptanceStatus === 'Rejected' && (
                          <Tag color="red" className="font-bold">
                            Rejected
                          </Tag>
                        )}
                        {(item?.AcceptanceStatus === 'Pending' ||
                          !item?.AcceptanceStatus) && (
                          <Tag color="gray" className="font-bold">
                            Pending
                          </Tag>
                        )}
                      </div>
                    </div>

                    <Dropdown
                      overlay={customMenu(
                        item?.Id,
                        item?.AcceptanceStatus === 'Pending',
                      )}
                    >
                      {item?.AcceptanceStatus === 'Pending' ? (
                        <IoIosArrowDropdownCircle
                          id="inviteMenu"
                          fontSize="1.5rem"
                          className="t-text-secondary-100 t-cursor-pointer"
                        />
                      ) : (
                        <>
                          <Tooltip title="View Event">
                            <GrView
                              id="viewEvent"
                              fontSize="1.2rem"
                              className="t-text-secondary-100 t-cursor-pointer"
                              onClick={() => onViewEventClick(item.Id)}
                            />
                          </Tooltip>
                        </>
                      )}
                    </Dropdown>
                  </Row>
                  <Row gutter={[24, 0]}>
                    <Tooltip title="Start Date">
                      {item?.StartDate && timeInAgo(item.StartDate)}
                    </Tooltip>
                  </Row>
                </Card>
              ))}
            </div>
          </Col>
        </Skeleton>
      </div>
    </Card>
  )
}

export { EventInvites }
